import { render } from "./MentionsLegales.vue?vue&type=template&id=74352c68"
import script from "./MentionsLegales.vue?vue&type=script&lang=js"
export * from "./MentionsLegales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__